import React, { useMemo } from "react";
import PropTypes from "prop-types";
import classNames from "../../../utils/classNames";
import LinkWithPreview from "../LinkWithPreview";
import "./index.scss";

const toUniqueUrls = (urls) => {
    const seenUrls = new Set();

    return (Array.isArray(urls) ? urls : []).filter((url) => {
        if (typeof url !== "string" || !url || seenUrls.has(url)) {
            return false;
        }

        seenUrls.add(url);
        return true;
    });
};

export default function LinkPreviewStack({ urls = [], className = "" }) {
    const normalizedUrls = useMemo(() => toUniqueUrls(urls), [urls]);

    if (!normalizedUrls.length) {
        return null;
    }

    return (
        <div className={classNames("link-preview-stack", className)}>
            {normalizedUrls.map((url) => (
                <LinkWithPreview
                    key={url}
                    url={url}
                    showTextLink={false}
                />
            ))}
        </div>
    );
}

LinkPreviewStack.propTypes = {
    urls: PropTypes.arrayOf(PropTypes.string),
    className: PropTypes.string,
};
